import { useEffect } from "react";

// load gtag and set default consent
export const useGoogleTag = (hasConsent: boolean) => {
    useEffect(() => {
        // set google Tag
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        function gtag() {
            // @ts-ignore
            dataLayer.push(arguments);
        }

        const script = document.createElement("script");
        const body = document.getElementsByTagName("body")[0];
        script.src = "https://www.googletagmanager.com/gtag/js?id=G-M1JLYEGB2N";
        body.appendChild(script);

        // @ts-ignore
        gtag("js", new Date());

        if (hasConsent) {
            // @ts-ignore
            gtag("consent", "update", {
                ad_storage: "granted",
                ad_user_data: "granted",
                ad_personalization: "granted",
                analytics_storage: "granted",
            });
        } else {
            // @ts-ignore
            gtag("consent", "default", {
                ad_storage: "denied",
                ad_user_data: "denied",
                ad_personalization: "denied",
                analytics_storage: "denied",
            });
        }
        // @ts-ignore
        gtag("config", "G-M1JLYEGB2N");
    }, [hasConsent]);
    return;
};
